import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class OrganizationService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}
	getApplications(payload) {
		return this._http.get(this.baseUrl + '/admin/applications/', { params: payload });
	}
	contractorAppAccess(payload) {
		return this._http.put(
			`${this.baseUrl}/admin/contractors/${payload.organizationId}/status/${payload.status}/`,
			payload.body
		);
	}
	migrate(payload) {
		return this._http.put(
			`${this
				.baseUrl}/admin/contractors/${payload.contractorId}/run_migration/?oldContractorUsername=${payload.old}`,
			''
		);
	}

	getMdas() {
		return this._http.get(`${this.baseUrl}/public/mdas/`);
	}

	startVerification(payload) {
		return this._http.post(
			`${this.baseUrl}/admin/contractors/${payload.contractorId}/bpp_verification/`,
			payload.body
		);
	}

	finalizeVerification(payload) {
		return this._http.post(
			`${this.baseUrl}/admin/contractors/${payload.contractorId}/bpp_verification/finalize/`,
			payload.body
		);
	}

	uploadContractors(payload) {
		return this._http.post(`${this.baseUrl}/admin/contractors/`, payload.body);
	}

	editTemporaryId(payload) {
		return this._http.put(`${this.baseUrl}/admin/contractors/${payload.organizationId}/`, payload.body);
	}

	exportContractorDetails(payload) {
		return this._http.get(`${this.baseUrl}/admin/contractors/${payload.contractorId}/bpp_verification/`, {
			params: payload.params
		});
	}

	createOrganization(payload) {
		return this._http.post(this.baseUrl + '/admin/organizations/', payload.body);
	}

	getOrganizationTypeRoles(payload) {
		return this._http.get(`${this.baseUrl}/admin/organization_types/payload.organizationTypeId/roles/`, {
			params: payload.params
		});
	}

	getOrganization(payload) {
		return this._http.get(`${this.baseUrl}/organizations/`, { params: payload.params });
	}

	// organization
	getOrganizations(payload) {
		return this._http.get(`${this.baseUrl}/organizations/${payload.organizationId}contractors/`, {
			params: payload.params
		});
	}
	getOrganizationsAdmin(payload) {
		return this._http.get(`${this.baseUrl}/organizations/`, { params: payload.params });
	}
	changeApiAccessStatus(payload) {
		return this._http.put(
			`${this.baseUrl}/admin/organizations/${payload.organizationId}/api/?status=${payload.status}`,
			payload.body
		);
	}

	changeContractorStatus(payload) {
		return this._http.put(
			`${this.baseUrl}/admin/contractors/${payload.contractorId}/bar/?status=${payload.status}`,
			payload.body
		);
	}

	addOrganizations(payload) {
		return this._http.post(`${this.baseUrl}/admin/organizations/`, payload.body);
	}

	updateOrganizations(payload) {
		return this._http.put(`${this.baseUrl}/admin/organizations/${payload.organizationId}/`, payload.body);
	}

	deleteOrganizations(payload) {
		return this._http.delete(`${this.baseUrl}/admin/organizations/${payload.organizationId}/`);
	}

	// organization Types
	getOrganizationTypes(payload) {
		return this._http.get(`${this.baseUrl}/organizations/types/`, { params: payload.params });
	}

	addOrganizationTypes(payload) {
		return this._http.post(`${this.baseUrl}/admin/organization_types/`, payload.body);
	}

	updateOrganizationTypes(payload) {
		return this._http.put(`${this.baseUrl}/admin/organization_types/${payload.organizationTypeId}/`, payload.body);
	}

	deleteOrganizationTypes(payload) {
		return this._http.delete(`${this.baseUrl}/admin/organization_types/${payload.organizationTypeId}/`);
	}

	exportCompaniesReport(payload) {
		return this._http.get(`${this.baseUrl}/organizations/${payload.organizationId}/contractors/export/`, {
			params: payload.params
		});
	}

	getDepartments() {
		return this._http.get(`${environment.API_SERVER}
        /organizations/?sord=desc&rows=100000000&page=1&_search=true&sidx=dateCreated&filters=
        %7B%22groupOp%22:%22AND%22,%22rules%22:%5B%7B%22field%22:%22organizationTypeId.organizationTypeId%22,
        %22op%22:%22eq%22,%22data%22:%22collaborator%22%7D,%7B%22field%22:%22organizationShortName%22,%22op%22:
        %22cn%22,%22data%22:%22%22%7D%5D%7D`);
	}

	getRoleFoDepartment() {
		return this._http.get(
			`${environment.API_SERVER}/admin/organization_types/collaborator/roles/?sord=desc&rows=100000000&page=1&_search=true&sidx=dateCreated`
		);
	}

	inviteExternalAppUsers(payload) {
		// tslint:disable-next-line: max-line-length
		return this._http.post(
			this.baseUrl +
				`/admin/invite_external_app_users/?roleId=${payload.rileId}&organizationId=${payload.organizationId}`,
			payload.body
		);
	}

	addDepartment(payload) {
		return this._http.post(`${this.baseUrl}/admin/organizations/`, payload);
	}
	update(payload) {
		return this._http.put(`${this.baseUrl}/organizations/${payload.organizationId}/`, payload.body);
	}
}
